import type { EnrichedReadyToSharePlatformPostV2 } from '#src/app/shared/api/readyToShare';

type TranslateFn = (key: string, replacements?: Partial<Readonly<Record<string, string | number>>>) => string;

export function getCTALabelForPostType(
	translate: TranslateFn,
	postTypeName: EnrichedReadyToSharePlatformPostV2['__typename'],
): string {
	return getCTALabels(translate)[postTypeName];
}

export function getSectionAriaLabelForPostType(
	translate: TranslateFn,
	postTypeName: EnrichedReadyToSharePlatformPostV2['__typename'],
): string {
	return getSectionAriaLabels(translate)[postTypeName];
}

export function getStartSharingAriaLabelForPostType(
	translate: TranslateFn,
	postTypeName: EnrichedReadyToSharePlatformPostV2['__typename'],
): string {
	return getStartSharingAriaLabels(translate)[postTypeName];
}

export function getCTALabels(translate: TranslateFn): Record<EnrichedReadyToSharePlatformPostV2['__typename'], string> {
	return {
		ReadyToShareFacebookPost: translate('corgi.petition.starter_dashboard_v2.shared.post_preview.cta.facebook_post'),
		ReadyToShareFacebookGroupsPost: translate(
			'corgi.petition.starter_dashboard_v2.shared.post_preview.cta.facebook_groups_post',
		),
		ReadyToShareFacebookStory: translate('corgi.petition.starter_dashboard_v2.shared.post_preview.cta.facebook_story'),
		ReadyToShareInstagramPost: translate('corgi.petition.starter_dashboard_v2.shared.post_preview.cta.instagram_post'),
		ReadyToShareInstagramStory: translate(
			'corgi.petition.starter_dashboard_v2.shared.post_preview.cta.instagram_story',
		),
		ReadyToShareRedditGroupsPost: translate(
			'corgi.petition.starter_dashboard_v2.shared.post_preview.cta.reddit_groups_post',
		),
	};
}

export function getSectionAriaLabels(
	translate: TranslateFn,
): Record<EnrichedReadyToSharePlatformPostV2['__typename'], string> {
	return {
		ReadyToShareFacebookPost: translate(
			'corgi.petition.starter_dashboard_v2.page_body.post_preview_card.section_aria_label.facebook_post',
		),
		ReadyToShareFacebookGroupsPost: translate(
			'corgi.petition.starter_dashboard_v2.page_body.post_preview_card.section_aria_label.facebook_groups_post',
		),
		ReadyToShareFacebookStory: translate(
			'corgi.petition.starter_dashboard_v2.page_body.post_preview_card.section_aria_label.facebook_story',
		),
		ReadyToShareInstagramPost: translate(
			'corgi.petition.starter_dashboard_v2.page_body.post_preview_card.section_aria_label.instagram_post',
		),
		ReadyToShareInstagramStory: translate(
			'corgi.petition.starter_dashboard_v2.page_body.post_preview_card.section_aria_label.instagram_story',
		),
		ReadyToShareRedditGroupsPost: translate(
			'corgi.petition.starter_dashboard_v2.page_body.post_preview_card.section_aria_label.reddit_groups_post',
		),
	};
}

export function getStartSharingAriaLabels(
	translate: TranslateFn,
): Record<EnrichedReadyToSharePlatformPostV2['__typename'], string> {
	return {
		ReadyToShareFacebookPost: translate(
			'corgi.petition.starter_dashboard_v2.page_body.post_preview_card.start_sharing_aria_label.facebook_post',
		),
		ReadyToShareFacebookGroupsPost: translate(
			'corgi.petition.starter_dashboard_v2.page_body.post_preview_card.start_sharing_aria_label.facebook_groups_post',
		),
		ReadyToShareFacebookStory: translate(
			'corgi.petition.starter_dashboard_v2.page_body.post_preview_card.start_sharing_aria_label.facebook_story',
		),
		ReadyToShareInstagramPost: translate(
			'corgi.petition.starter_dashboard_v2.page_body.post_preview_card.start_sharing_aria_label.instagram_post',
		),
		ReadyToShareInstagramStory: translate(
			'corgi.petition.starter_dashboard_v2.page_body.post_preview_card.start_sharing_aria_label.instagram_story',
		),
		ReadyToShareRedditGroupsPost: translate(
			'corgi.petition.starter_dashboard_v2.page_body.post_preview_card.start_sharing_aria_label.reddit_groups_post',
		),
	};
}
